import axios from "axios";
import auth from "./auth";
import Store from "../store/index";
const baseURL = Store.state.apiURL;

export default {
  getUserInfo() {
    var jwtToken = auth.auth.getSignInUserSession().getAccessToken().jwtToken;
    const USERINFO_URL =
      "https://" + auth.auth.getAppWebDomain() + "/oauth2/userInfo";
    var requestData = {
      headers: {
        Authorization: "Bearer " + jwtToken,
        crossDomain: true
      },
    };

    return axios.get(USERINFO_URL, requestData).then((response) => {

      return this.getUserDetailsAPICall(response.data.email, response.data.username);

    }).catch(() => {
      auth.logout();
      return;
    });
  },
  getUserDetailsAPICall(_email, _username) {
    const accessToken = auth.auth.signInUserSession.idToken.jwtToken;
    const jwtHeader = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        CompanyId: Store.state.cognitoInfo.companyid == undefined
          || Store.state.cognitoInfo.companyid == null
          || Store.state.cognitoInfo.companyid == "undefined"
          || Store.state.cognitoInfo.companyid == "null" ? "" : Store.state.cognitoInfo.companyid,
        crossDomain: true
      },
    };
    return axios
      .get(baseURL + "/user/getuserinfo", jwtHeader)
      .then((userRes) => {

        if (userRes.data.companyId == "" || userRes.data.companyId == null || userRes.data.companyId == undefined) {
          auth.logout();
          return;
        }
        var mainres = {};
        mainres.email = _email;
        mainres.username = _username;
        mainres.displayname = userRes.data.displayName;
        mainres.companyid = userRes.data.companyId;
        mainres.companyname = userRes.data.companyName;
        mainres.companylist = userRes.data.companyIdList;
        mainres.role = userRes.data.role;
        // Store.commit("setCognitoInfo", userRes);
        return mainres;
      }).catch(() => {
        auth.logout();
        return;
      });
  }
};
